import * as api from "services/api";
import { getErrors } from "helpers/error";
import { Callback } from "Types/Callback";
import IBankBillet from "Types/BankBillet";
import { State } from "store/reducers";

export const GET_TRANSFER = "[TRANSFER GET] GET_TRANSFER";
export const GET_TRANSFER_SUCCESS = "[TRANSFER GET] GET_TRANSFER_SUCCESS";
export const GET_TRANSFER_FAILED = "[TRANSFER GET] GET_TRANSFER_FAILED";

export const SET_VALUE = "[TRANSFER GET] SET_VALUE";
export const CLEAR_VALUES = "[TRANSFER GET] CLEAR_VALUES";

export function setValue(payload: any) {
	return { type: SET_VALUE, payload };
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function getBankBillet(id: string, callback?: Callback<IBankBillet>) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: GET_TRANSFER });

		try {
			const { login } = getState() as State;

			const response = await api.sendGet("/BankBillet/" + id, {
				Authorization: `Bearer ${login.token}`
			});

			const result = await response.json();

			if (result.isValid) {
				dispatch({
					type: GET_TRANSFER_SUCCESS,
					payload: result.model
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_TRANSFER_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			callback && callback(error);

			return dispatch({
				type: GET_TRANSFER_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export const GET_SPLITS = "[TRANSFER GET] GET_SPLITS";
export const GET_SPLITS_SUCCESS = "[TRANSFER GET] GET_SPLITS_SUCCESS";
export const GET_SPLITS_FAILED = "[TRANSFER GET] GET_SPLITS_FAILED";

export function getSplits(id: string, callback?: Callback<IBankBillet>) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: GET_SPLITS });

		try {
			const { login } = getState() as State;

			const response = await api.sendGet("/BankBillet/" + id + "/Splits", {
				Authorization: `Bearer ${login.token}`
			});

			const result = await response.json();

			if (result.isValid) {
				dispatch({
					type: GET_SPLITS_SUCCESS,
					payload: result.model
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_SPLITS_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			callback && callback(error);

			return dispatch({
				type: GET_SPLITS_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export const CREATE_SPLIT = "[TRANSFER GET] CREATE_SPLIT";
export const CREATE_SPLIT_SUCCESS = "[TRANSFER GET] CREATE_SPLIT_SUCCESS";
export const CREATE_SPLIT_FAILED = "[TRANSFER GET] CREATE_SPLIT_FAILED";

export function createSplit(
	id: any,
	model: any,
	callback?: Callback<IBankBillet>
) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: CREATE_SPLIT });

		try {
			const { login } = getState() as State;

			const response = await api.sendPost(
				"/BankBillet/" + id + "/Splits",
				model,
				{
					Authorization: `Bearer ${login.token}`
				}
			);

			const result = await response.json();

			if (result.isValid) {
				dispatch({
					type: CREATE_SPLIT_SUCCESS,
					payload: result.model
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: CREATE_SPLIT_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			console.log(error);

			callback && callback(error);

			return dispatch({
				type: CREATE_SPLIT_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
